import Vue from 'vue';
import moment from 'moment';
import FormHeader from "./components/shared/FormHeader.vue";
import FormButton from './components/shared/FormButton.vue';
import FloatButton from './components/shared/FloatButton.vue';
import FloatSubmitButton from './components/shared/FloatSubmitButton.vue';
import FilterBar from './components/shared/FilterBar.vue'
import FilterInput from './components/shared/FilterInput.vue'
import BlumarDecimalInput from './components/shared/BlumarDecimalInput.vue';
import Multiselect from "vue-multiselect";
import BlumarMultiselect from './components/shared/BlumarMultiSelect.vue';
import CircleButton from './components/shared/CircleButton.vue';
import FloatOptionsButton from './components/shared/FloatOptionsButton.vue';
import Fixed from './components/shared/Fixed.vue';
import CircleToggler from './components/shared/CircleToggler.vue';
import InlineFieldset from './components/shared/InlineFieldset.vue';
import InlineInputGroup from './components/shared/InlineInputGroup.vue';
import LabeledInput from './components/shared/LabeledInput.vue';
import LabeledSelect from './components/shared/LabeledSelect.vue';
import BasePage from './components/shared/BaseListingPage.vue'
import OptionsButton from './components/shared/OptionsButton.vue';

Vue.component('form-button', FormButton);
Vue.component('float-button', FloatButton);
Vue.component('float-submit-button', FloatSubmitButton);
Vue.component('form-header', FormHeader);
Vue.component('filter-bar', FilterBar);
Vue.component('filter-input', FilterInput);
Vue.component('blumar-decimal-input', BlumarDecimalInput);
Vue.component('multiselect', Multiselect);
Vue.component('blumar-multiselect', BlumarMultiselect);
Vue.component('circle-button', CircleButton);
Vue.component('float-options-button', FloatOptionsButton);
Vue.component('fixed', Fixed);
Vue.component('circle-toggler', CircleToggler);
Vue.component('inline-fieldset', InlineFieldset);
Vue.component('inline-input-group', InlineInputGroup);
Vue.component('labeled-input', LabeledInput)
Vue.component('labeled-select', LabeledSelect);
Vue.component('options-button', OptionsButton);
Vue.component('base-listing-page', BasePage);

Vue.filter('date', function(value) {
	if (value) {
	  return moment(String(value)).format('DD/MM/YYYY');
	}
});

Vue.filter('datetime', function(value) {
	if (value) {
	  return moment(String(value)).format('DD/MM/YYYY hh:mm');
	}
});

Vue.filter('number', function(value) {
	return value.toString().replace(/,/g, '!').replace(/\./g, ',').replace(/!/g, '.');
});



// WEBPACK FOOTER //
// ./src/components.js